import React from 'react'

const DayHead = ({date, now, onClick, ...root}) => {
  const isCurrentDay = date.isSame(now, 'day')
  const day = date.format('D')
  const dayOfWeek = date.format('dddd')
  return (
    <div
      {...root}
      className={`day-head ${isCurrentDay ? 'day-head--selected' : ''}`}
      data-x="all-day-range"
    >
      <div className="day-head__day" onClick={onClick}>
        {day}
      </div>
      <div className="day-head__day-of-week" data-x="all-day-range">
        {dayOfWeek}
      </div>
    </div>
  )
}

export default DayHead
